import { Clock, Users, CreditCard, UserCog, FileCheck2, BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, RevealGroup, RevealItem } from "@/components/Reveal";
import { PageHero, CTABand } from "@/components/Bits";
import { HERO_IMG } from "@/lib/site";

const POINTS = [
  { icon: Clock, title: "20 Years of Trust", desc: "Two decades of dependable service, earning the confidence of clients who travel with us again and again." },
  { icon: Users, title: "1000+ Clients Served", desc: "Hundreds of corporate organizations, and thousands of executives and families served with tailored, reliable mobility solutions." },
  { icon: CreditCard, title: "Corporate Credit Support", desc: "Flexible 10–15 day credit facility built around corporate cash flow and approval cycles." },
  { icon: UserCog, title: "Dedicated Account Managers", desc: "A single, accountable point of contact who knows your company and handles every detail personally." },
  { icon: FileCheck2, title: "End to End Visa Support", desc: "Complete visa handling from documentation and form filling to embassy liaison and appointments." },
  { icon: BadgeCheck, title: "High Visa Approval Rate", desc: "Precision and experience that consistently translate into strong visa approval outcomes." },
];

export default function WhyFlyGowell() {
  return (
    <div data-testid="why-page">
      <PageHero
        overline="Why Fly Gowell"
        title="Not a travel agency. A mobility partner."
        subtitle="The differentiators that make Fly Gowell the strategic choice for corporate travel."
        image={HERO_IMG}
      />

      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 pb-24 md:pb-32">
        <RevealGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {POINTS.map((p) => (
            <RevealItem key={p.title}>
              <Link to="/contact" data-testid={`why-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group block h-full rounded-2xl border border-brand-blue/8 bg-white p-8 hover:-translate-y-1.5 hover:shadow-xl hover:border-brand-green/30 transition-all cursor-pointer">
                <div className="inline-flex rounded-xl bg-gradient-to-br from-brand-blue to-brand-green p-3.5 text-white transition-transform group-hover:scale-110">
                  <p.icon size={24} />
                </div>
                <h3 className="mt-6 text-xl font-heading font-semibold text-brand-blue">{p.title}</h3>
                <p className="mt-3 text-brand-slate leading-relaxed">{p.desc}</p>
              </Link>
            </RevealItem>
          ))}
        </RevealGroup>
      </section>

      {/* Callout banner */}
      <section className="relative overflow-hidden bg-brand-blue">
        <div className="grain absolute inset-0" />
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-24 md:py-36 relative">
          <Reveal>
            <p className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight text-white max-w-5xl">
              We&apos;re not a travel agency.{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-green to-brand-yellow">
                We&apos;re your corporate mobility partner.
              </span>
            </p>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
